import React, {useState, useEffect} from 'react';

import {useSelector} from 'react-redux';

import AISearchMenuContainer from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/AISearchMenuContainer';
import {
  AppSwitcherMenu
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/AppSwitcherMenu';
import {HomeMenu} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/HomeMenu';
import {
  navigationBarContainerCss,
  navigationBarLeftContainerCss,
  navigationBarRightContainerCss,
  trialButtonsVisibilityCss
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/NavigationBar.styles';
import {NewselaLogo} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/NewselaLogo';
import {ResourceMenus} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/ResourceMenus';
import {SearchMenu} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SearchMenu';
import {
  SkipToContentButton
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SkipToContentButton';
import {SubjectItems} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SubjectItems';
import {SupportCenter} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/SupportCenter';
import {
  UserProfileMenu
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/UserProfileMenu';
import {getUserProperties} from 'static/three-oh/src/modules/selectors/userSelectors';

import {useNavigationBarV2Context} from './NavigationBar.provider';
import {TrialButtons} from './PremiumTrial/TrialButtons';
import TrialModal from '../../../TrialModal';


const NavigationBar = () => {
  const {canSeeAiFeatures, getExperimentSegment, canViewSearch} = useSelector((state) => getUserProperties(state));
  const isAiSmartSearchExperimentOn = getExperimentSegment('ai_assisted_search') === 'on';
  const canSeeAiSmartSearch = canSeeAiFeatures && isAiSmartSearchExperimentOn;

  const [isAISearchEnabled, setIsAISearchEnabled] = useState(true);
  const [shouldShowAISearch, setShouldShowAISearch] = useState(true);
  // renamed for reset any previously stored false, so all the users can see the Luna search experience
  const SEARCH_LUNA_KEY = 'isSearchWithLunaEnabled_v2';

  useEffect(() => {
    const isSearchWithLunaEnabled = localStorage.getItem(SEARCH_LUNA_KEY);
    if (isSearchWithLunaEnabled !== null) {
      const parsed = isSearchWithLunaEnabled === 'true';
      setIsAISearchEnabled(parsed);
      setShouldShowAISearch(parsed);
    } else {
      setIsAISearchEnabled(true);
      setShouldShowAISearch(true);
    }
  }, []);

  const handleAISearchToggle = (value) => {
    setIsAISearchEnabled(value);
    localStorage.setItem(SEARCH_LUNA_KEY, String(value));

    setTimeout(() => {
      setShouldShowAISearch(value);
    }, 300);
  };

  const {
    trialModal: {
      trialModalProps,
    }
  } = useNavigationBarV2Context();

  return (
    <>
      <header>
        <nav className={navigationBarContainerCss}>
          <ul className={navigationBarLeftContainerCss}>
            <AppSwitcherMenu/>
            <NewselaLogo/>
            {canViewSearch && (canSeeAiSmartSearch && shouldShowAISearch ? (
              <AISearchMenuContainer
                onToggle={handleAISearchToggle}
                isAISearchEnabled={isAISearchEnabled}
              />
            ) : (
              <SearchMenu
                onToggle={handleAISearchToggle}
                isAISearchEnabled={isAISearchEnabled}
              />
            ))}
            <SkipToContentButton/>
          </ul>

          <ul className={navigationBarRightContainerCss}>
            <SubjectItems/>
            <ResourceMenus/>
            <HomeMenu/>
            <TrialButtons customCss={trialButtonsVisibilityCss}/>
            <UserProfileMenu/>
            <SupportCenter/>
          </ul>
        </nav>

        <TrialModal {...trialModalProps} />
      </header>
    </>
  );
};

NavigationBar.displayName = 'NavigationBar';
export {NavigationBar};
